import { createRequestTypes } from "../utils";

export const SET_LOADING_SPOREXPERT_USER = 'SET_LOADING';

// Get SporexpertUser
export const GET_SPOREXPERT_USER = createRequestTypes("GET_SPOREXPERT_USER");

// Update SporexpertUser
export const UPDATE_SPOREXPERT_USER = createRequestTypes("UPDATE_SPOREXPERT_USER");

// Set SporexpertUser
export const SET_SPOREXPERT_USER = createRequestTypes("SET_SPOREXPERT_USER");

export const setSporexpertUser = (sporexpertuser) => ({ type: SET_SPOREXPERT_USER.REQUEST, payload: { sporexpertuser } });

// Update
export const updateSporexpertUser = (data) => ({ type: UPDATE_SPOREXPERT_USER.REQUEST, payload: { data } });
export const updateSporexpertUserSuccess = (sporexpertuser) =>
    ({ type: UPDATE_SPOREXPERT_USER.SUCCESS, payload: { sporexpertuser } });
export const updateSporexpertUserFailure = (errorSporexpertuser) =>
    ({ type: UPDATE_SPOREXPERT_USER.FAILURE, payload: { errorSporexpertuser } });
